import { ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SPECS = [
  { code: "NR-35", desc: "Equipe certificada para trabalho em altura, com treinamento em dia e reciclagem programada." },
  { code: "ART", desc: "Anotação de Responsabilidade Técnica emitida em toda obra. Engenharia assinando junto." },
  { code: "SEGURO", desc: "Seguro de vida em vigor para 100% da equipe em campo, todos os dias." },
  { code: "EPI · CA", desc: "Equipamentos com Certificado de Aprovação, inspecionados antes de cada descida." },
];

export const Safety = () => (
  <section id="seguranca" data-testid="safety-section" className="relative overflow-hidden">
    <img
      src="https://images.pexels.com/photos/18101014/pexels-photo-18101014.jpeg?auto=compress&cs=tinysrgb&w=1600"
      alt=""
      className="absolute inset-0 h-full w-full object-cover opacity-20"
      loading="lazy"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />
    <div className="relative mx-auto max-w-7xl px-6 py-24 md:py-32">
      <Reveal>
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-krono">[ Segurança ]</p>
        <h2 className="max-w-2xl font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
          Altura não é improviso. É protocolo.
        </h2>
      </Reveal>
      <div className="mt-16 max-w-3xl border-t border-white/10">
        {SPECS.map((s, i) => (
          <Reveal key={s.code} delay={i * 0.06}>
            <div
              data-testid={`safety-spec-${s.code.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
              className="group flex items-start gap-5 border-b border-white/10 py-7 transition-colors hover:bg-white/5 md:items-center"
            >
              <ShieldCheck className="mt-1 h-5 w-5 shrink-0 text-krono md:mt-0" />
              <span className="w-28 shrink-0 font-mono text-sm font-bold tracking-widest text-krono">{s.code}</span>
              <p className="text-sm leading-relaxed text-white/70">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
